/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react'
import { connect } from 'react-redux'
import forEach from 'lodash/forEach'
import firebase from 'firebase/app'
import moment from 'moment'
import { Segment, Grid, Header, Button } from 'semantic-ui-react'

import ExpressActions from '../../../reducers/expressReducer'

import DateField from '../../../components/adminReport/fields/dateRangeSearchField'

class ExpressReport extends React.Component {
  state = {
    downloading: false,
    downloadUrl: '',
    startFrom: Number(
      moment()
        .startOf('month')
        .format('x')
    ),
    endAt: Number(
      moment()
        .endOf('month')
        .format('x')
    ),
  }

  downloadFile = snapshot => {
    const self = this
    snapshot.ref.getDownloadURL().then(downloadUrl => {
      self.setState({ downloading: false, downloadUrl }, () => {
        self.downloadLinkRef.click()
      })
    })
  }

  uploadFile = async csvString => {
    const { startFrom, endAt } = this.state
    const startDate = moment(startFrom).format('YYYY-MMM-DD')
    const endDate = moment(endAt).format('YYYY-MMM-DD')

    const storage = firebase
      .storage()
      .ref()
      .child(`report/express-report-${startDate}-to-${endDate}.csv`)

    this.setState({ downloading: true })

    return storage.putString(csvString.toString())
  }

  calculateCollectPayment = order => {
    let collectPayment = 0

    const receivers = Object.values(order.receivers || {})

    receivers.forEach(receiver => {
      if (receiver.status === 'delivered') collectPayment += receiver.collect_payment
    })

    return parseFloat(collectPayment).toFixed(2)
  }

  calculateCommissionEarn = (totalDeliveryFee, commissionRate) => {
    const commissionFee = (totalDeliveryFee * commissionRate) / 100
    return parseFloat(commissionFee).toFixed(2)
  }

  generateCSV = async (orders) => {
    let csvString = ''
    const headers = [
      'No.',
      'Customer Name',
      'Customer Tel',
      'Bank Account Name',
      'Bank Account Number',
      'COD',
      'Delivery Fees',
      'Commission Rate',
      'Commission Earn',
      'Driver Name',
      'Driver Tel',
      'Date Time',
      'Settlement Status',
      'Order Status',
    ].join(', ')

    csvString = csvString.concat(`${headers} \n`)

    forEach(orders, (order, key) => {
      if (order.status === 'drafted') return

      const cod = this.calculateCollectPayment(order)
      const totalDeliveryFee = order.delivery_fee || 0
      const commissionRate = order.delivery_commission_rate || 0

      const commissionEarn = this.calculateCommissionEarn(totalDeliveryFee, commissionRate)

      let settlementStatus = ''

      if (order.is_using_cod) {
        settlementStatus = order.refunded ? 'Paid' : 'Unpaid'
      }

      const rowString = [
        key + 1,
        order.requestor.name,
        order.requestor.phone,
        order.bank_account_name,
        `'${order.bank_account_number}`,
        `$${cod || 0}`,
        `$${order.delivery_fee}`,
        `${commissionRate}`,
        `$${commissionEarn}`,
        order.deliverer_name || 'N/A',
        order.deliverer || 'N/A',
        moment(order.created_at).format('DD MMMM YYYY - h:mma'),
        settlementStatus,
        order.status,
      ]

      csvString = csvString.concat(`${rowString} \n`)
    })

    return csvString
  }

  onDownloadClick = async () => {
    const { expressReport } = this.props

    const csvString = await this.generateCSV(expressReport)

    const snapshot = await this.uploadFile(csvString)
    this.downloadFile(snapshot)
  }

  onFieldChange = (field, value) => {
    this.setState({ [field]: value })
  }

  validateSearchByDate = () => {
    const { startFrom, endAt } = this.state

    if (startFrom > endAt) {
      return false
    }

    return true
  }

  onSearch = () => {
    const { startFrom, endAt } = this.state
    const { getExpressOrders } = this.props

    const validateDate = this.validateSearchByDate()

    if (validateDate) {
      getExpressOrders({ startFrom, endAt })
    } else {
      alert('Date invalid, please check it again')
    }
  }

  getStatistics = (orders) => {
    let successCount = 0
    let rejectedCount = 0

    forEach(orders, order => {
      if (order.status === 'delivered') successCount += 1
      if (order.status === 'rejected') rejectedCount += 1
    })

    return { successCount, rejectedCount }
  }

  render() {
    const { startFrom, endAt, downloadUrl, downloading } = this.state
    const { expressReport, loading } = this.props

    const statistics = expressReport.length > 0 ? this.getStatistics(expressReport) : {}

    return (
      <Segment style={{ height: '100%', overflow: 'auto' }}>
        <div style={{ padding: '0px 14px' }}>
          <DateField
            startFrom={startFrom}
            endAt={endAt}
            loading={loading}
            onSearch={this.onSearch}
            onFieldChange={this.onFieldChange}
          />

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginTop: 20,
            }}
          >
            <Button
              disabled={expressReport.length === 0}
              loading={downloading}
              onClick={this.onDownloadClick}
            >
              Download Report
            </Button>
            <a href={downloadUrl} ref={ref => { this.downloadLinkRef = ref }} style={{ display: 'none' }} />
          </div>

          <Grid columns="equal" style={{ marginTop: 15 }}>
            <Grid.Column>
              <Segment textAlign="center">
                <Header size="medium">Completed Orders</Header>
                <Header size="medium">{statistics.successCount || 0}</Header>
              </Segment>
            </Grid.Column>
            <Grid.Column>
              <Segment textAlign="center">
                <Header size="medium">Rejected Orders</Header>
                <Header size="medium">{statistics.rejectedCount || 0}</Header>
              </Segment>
            </Grid.Column>
          </Grid>
        </div>
      </Segment>
    )
  }
}

const mapState = ({ express }) => ({
  expressReport: express.expressOrdersReport,
  loading: express.exportReportLoading,
})

const mapDispatch = {
  getExpressOrders: ExpressActions.getExpressOrdersReport,
}

export default connect(mapState, mapDispatch)(ExpressReport)



// WEBPACK FOOTER //
// ./src/containers/reports/sale/express.js